module.exports = [{"name":"EASY","icon":{"type":"icon","name":"update"}},{"name":"AUTHENTICATION","icon":{"type":"icon","name":"lock"}},{"name":"VIEWS","icon":{"type":"icon","name":"library_books"}},{"name":"LOGIN","icon":{"type":"icon","name":"brush"}},{"name":"MANAGEMENT","icon":{"type":"icon","name":"group_add"}},{"name":"STATS","icon":{"type":"icon","name":"equalizer"}}]


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/passwordprotect/service-garden.json
// module id = J44G
// module chunks = 0